module.exports = __webpack_public_path__ + "img/admin1.6fe3c6a1.png";